// Creates the initial texture from the base geometry's positions.
export default function createBaseParticlesTexture(gpu, geometry, count) {
    const texture = gpu.createTexture()
    const posArray = geometry.attributes.position.array
    for (let i = 0; i < count; i++) {
        const i3 = i * 3
        const i4 = i * 4 // RGBA channels
        texture.image.data[i4 + 0] = posArray[i3 + 0]
        texture.image.data[i4 + 1] = posArray[i3 + 1]
        texture.image.data[i4 + 2] = posArray[i3 + 2]
        texture.image.data[i4 + 3] = Math.random()
    }
    return texture
}